package com.starparty.app.astro0

import com.starparty.app.geometry.SP_Point
import com.starparty.app.vector_maths.Matrix4d
import com.starparty.app.vector_maths.Point3d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class SteriographicProjection :
    Projection(STERIOGRAPHIC) {
    /** Given a point on screen 'p' returns the unprojected
     * cartesian coordinates of that point on a unit sphere  */
    override fun invertProjection(p: SP_Point?): Point3d {
        val A = (p!!.x * p.x + p.y * p.y) / (zoomFactor * zoomFactor)
        val z = (1 - A) / (1 + A)
        val x = -p.x * (z + 1) / zoomFactor
        val y = -p.y * (z + 1) / zoomFactor
        return Point3d(x, y, z)
    }

    companion object {
        val STERIOGRAPHIC = Matrix4d(
            (-1).toDouble(), 0.0, 0.0, 0.0,
            0.0, (-1).toDouble(), 0.0, 0.0,
            0.0, 0.0, 1.0, 1.0,
            0.0, 0.0, 0.0, 1.0
        )
    }
}